'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouterLink = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Route = require('react-router/Route');

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RouterLink = exports.RouterLink = function RouterLink(_ref) {
  var _ref$component = _ref.component,
      Link = _ref$component === undefined ? 'a' : _ref$component,
      to = _ref.to,
      _ref$exact = _ref.exact,
      exact = _ref$exact === undefined ? false : _ref$exact,
      _ref$children = _ref.children,
      _children = _ref$children === undefined ? null : _ref$children;

  return React.createElement(_Route2.default, { exact: exact, path: to, children: function children(_ref2) {
      var match = _ref2.match;
      return React.createElement(Link, { to: to, active: match, onKeyPress: function onKeyPress(e) {
          return e.key === ' ' && e.target.click();
        } }, _children);
    } });
};
//# sourceMappingURL=router-link.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/components/router-link.js
 ** module id = 146
 ** module chunks = 0
 **/